import { useMemo, useState } from 'react'
import { PickingStatus } from '../../../../constants/picking-status'
import { usePickingManualContext } from '../../../../contexts/PickingContext'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'
import {
  getPeriodoMesAtual,
  parseToMysqlFormatWithTime,
} from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import { menuItemsAllowed } from '../../../../services/permission/menus'

export const MENU_ITEMS = [
  '1. Editar',
  '3. Assoc Entregas',
  '4. Assoc Areas de Separacao',
  '5. Resumo de Separação',
]

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  FILTERING: 'Filtrando dados',
  DELETE: 'Apagando separação',
  SUCCESS_DELETE: 'Separação deletada com sucesso',
}

const MODAL_INIT_INFO = {
  id: null,
  name: '',
  style: 'Manual',
  status: 'Sem Entregas Associadas',
  company_id: '',
}

const INITIAL_STATE = {
  pickings: [],
  filterdPickings: [],
  modal: {
    show: false,
    data: null,
  },
  periodo: getPeriodoMesAtual(),
  selectedPick: 0,
  pathToRedirect: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  modalConfirmDelete: {
    show: false,
    data: null,
  },
  empresas: [],
  selectedEmpresa: [],
  status: [],
  selectedStatus: [],
}

export default function usePickingManual() {
  const context = usePickingManualContext()
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions

      toggleModal(show, data, tp_id) {
        if (tp_id !== 0)
          setState(prevState => ({
            ...prevState,
            modal: { show, data: { ...data, tp_id: tp_id } },
          }))
        else
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione o Operador Logístico desejado',
          }))
      },

      getPickings(dataInicial, dataFinal, selectedTp) {
        PickingHttp.getPickings(
          selectedTp,
          'Manual',
          'all',
          parseToMysqlFormatWithTime(dataInicial),
          parseToMysqlFormatWithTime(dataFinal),
        )
          .then(pickings =>
            setState(prev => ({
              ...prev,
              pickings,
              filterdPickings: pickings,
              status: Array.from(new Set(pickings.map(p => p.status))).map(s => ({
                value: s,
                label: s,
              })),
              empresas: Array.from(new Set(pickings.map(p => p.company_name))).map(e => ({
                value: e,
                label: e,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prev => ({
              ...prev,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      onFilterChange(name, value) {
        setState(prev => ({ ...prev, [name]: value }))
      },

      filterPickings(pickings, selectedEmpresa, selectedStatus) {
        let filtered = pickings

        if (selectedEmpresa.length > 0) {
          filtered = filtered.filter(p => selectedEmpresa.includes(p.company_name))
        }
        if (selectedStatus.length > 0) {
          filtered = filtered.filter(p => selectedStatus.includes(p.status))
        }

        setState(prev => ({ ...prev, filterdPickings: filtered }))
      },

      deletePick(pick) {
        PickingHttp.apagarPicking(pick.id)
          .then(() =>
            setState(prev => {
              const pickings = prev.pickings.filter(p => p.id !== pick.id)
              let filtered = pickings
              const selEmp = prev.selectedEmpresa.map(e => e.value)
              const selSta = prev.selectedStatus.map(s => s.value)
              if (selEmp.length > 0)
                filtered = filtered.filter(p => selEmp.includes(p.company_name))
              if (selSta.length > 0) filtered = filtered.filter(p => selSta.includes(p.status))

              return {
                ...prev,
                pickings,
                filterdPickings: filtered,
                loadingMessage: LOAD_MESSAGE.SUCCESS_DELETE,
              }
            }),
          )
          .catch(err =>
            setState(prev => ({
              ...prev,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          pathToRedirect: null,
        }))
      },

      //Events

      onInit(selectedTp) {
        if (selectedTp === 0) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione o Operador Logístico desejado',
          }))
        } else {
          setState(prevState => ({
            ...prevState,
            periodo: context.pickingManualContext.selectedPeriodo,
            loadingMessage: LOAD_MESSAGE.FILTERING,
          }))
        }
      },

      onBtnNovo(selectedTp) {
        this.toggleModal(true, { ...MODAL_INIT_INFO }, selectedTp)
      },

      onModalClose() {
        setState(prevState => ({
          ...prevState,
          modal: { show: false, data: { ...MODAL_INIT_INFO } },
        }))
      },

      onModalSave(pick) {
        setState(prevState => {
          const index = prevState.pickings.findIndex(l => l.id === pick.id)
          if (index !== -1) prevState.pickings[index] = pick
          else prevState.pickings.unshift(pick)
          prevState.modal = { show: false, data: null }
          return { ...prevState }
        })
      },

      onMenuItemClicked(item, pick, selectedTp) {
        switch (item) {
          case '1. Editar':
            this.onMenuItemEditarClicked(pick, selectedTp)
            break
          case '2. Apagar':
            setState(prevState => ({
              ...prevState,
              modalConfirmDelete: { show: true, data: { ...pick } },
            }))
            break
          case '3. Assoc Entregas':
            setState(prevState => ({
              ...prevState,
              pathToRedirect: '/main/picking/assoc-entrega',
              selectedPick: pick,
            }))
            break
          case '4. Assoc Areas de Separacao':
            setState(prevState => ({
              ...prevState,
              pathToRedirect: '/main/picking/assoc-area',
              selectedPick: pick,
            }))
            break
          case '5. Resumo de Separação':
            if (pick.status === 'Com Entregas Associadas' || pick.status === 'Resumo Emitido')
              setState(prevState => ({
                ...prevState,
                pathToRedirect: '/main/picking/resumo-separacao-manual',
                selectedPick: pick,
              }))
            else
              setState(prevState => ({
                ...prevState,
                errorMessage:
                  'Somente o Picking com os status: COM_ENTREGA_ASSOCIADA ou RESUMO_EMITIDO pode acessar o Resumo da Separação',
              }))

            break
          default:
            break
        }
      },

      onMenuItemEditarClicked(pick, selectedTp) {
        const isEditable = pick.status === PickingStatus.SemEntregasAssociadas.label
        this.toggleModal(true, { ...pick, viewOnly: !isEditable }, selectedTp)
      },

      onMenuItemApagarClicked(pick) {
        setState(prevState => ({
          ...prevState,
          selectedPick: pick,
          loadingMessage: LOAD_MESSAGE.DELETE,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalDeleteClose() {
        setState(prevState => ({
          ...prevState,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalDeleteSave(pick) {
        this.onMenuItemApagarClicked(pick)
      },

      onBtnPesquisarClick(dataInicial, dataFinal) {
        context.setPickingManualContext(prevPickingManualContext => ({
          ...prevPickingManualContext,
          selectedPeriodo: { dataInicial, dataFinal },
        }))
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial, dataFinal },
          loadingMessage: LOAD_MESSAGE.FILTERING,
        }))
      },

      verifyMenuItemAllowed(menuItem) {
        return menuItemsAllowed([menuItem]).length > 0
      },
    }
  }, [])

  return { state, localDispatch }
}
